import { clsx } from 'clsx';
import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { DialogContent } from '@optiaxiom/react';

import * as styles from './spotlight.css';

export type SpotlightContentProps = ComponentPropsWithoutRef<typeof DialogContent>;

/**
 * The Spotlight panel — a styled Axiom `DialogContent` (640px, edge-to-edge)
 * that renders the input (and, later, a results list) as children. Carries an
 * accessible name since it has no `DialogHeader`/close button.
 */
export const SpotlightContent = forwardRef<HTMLDivElement, SpotlightContentProps>(
  ({ children, className, onPointerDownOutside, ...props }, ref) => (
    <DialogContent
      aria-label="Command palette"
      className={clsx(styles.content, className)}
      // Axiom's DialogContent blocks outside-click dismissal by default (its
      // fallback preventDefaults the event). Supplying a non-preventing handler
      // restores the expected click-outside-to-close behavior.
      onPointerDownOutside={onPointerDownOutside || (() => {})}
      ref={ref}
      {...props}
    >
      {children}
    </DialogContent>
  )
);

SpotlightContent.displayName = 'SpotlightContent';
